import React, {PureComponent} from 'react';
import {Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StoreBtn = styled(Button).attrs({
  className: 'btn-primary',
})`
  &&& {
    font-family: Montserrat-Semi-Bold, 'sans-serif';
    width: 250px;
    font-size: 16px;
    border-radius: 30px;
    background-color: #323232;
    border-color: transparent;
    height: 60px;
    box-shadow: 0px 6px 20.9px -10px black;
  }
`;

class CustomButton extends PureComponent {
  render() {
    const {text} = this.props;
    return <StoreBtn className={'custom-btn'} {...this.props}>{text}</StoreBtn>;
  }
}

CustomButton.propTypes = {
  text: PropTypes.string.isRequired,
};

export default CustomButton;
